// extracted by mini-css-extract-plugin
export default {"personalInfoCard":"PersonalInfo_personalInfoCard__-T64V","submitButton":"PersonalInfo_submitButton__8BrA4"};